import styled from '@emotion/styled';
import React from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { __permissionsObj, __snackBarSeverity, __snackBarText } from '../../constants';
import mainContext from '../../contexts/mainContext';
import { addNonaFeesController, getCountryCitiesListing, getNonaFeesController, removeNonaFee } from '../../Controllers/ScopeManagement';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import EditMenu from '../../common_components/EditMenu';
import moment from 'moment';
import { Delete, Edit, Remove, RemoveCircle } from '@mui/icons-material';

function FormDialog({ open, handleClose, handleAddUpdate, nonaFee }) {
    const [state, setState] = React.useState({
        country: [],
        selectedCity: nonaFee.city,
        selectedCountryId: nonaFee.countryId,
        minHours: nonaFee.minHours,
        weekendFeePerHour: nonaFee.weekEndFeePerHour,
        feePerHour: nonaFee.feePerHour,
        applicableFrom: nonaFee.applicableFrom ? new Date(nonaFee.applicableFrom) : new Date(),
        applicableTo: nonaFee.applicableTo ? new Date(nonaFee.applicableTo) : new Date(),
        _id: nonaFee._id || null,
        status: nonaFee.status || "Active"
    })

    React.useEffect(() => {
        async function getCountry() {
            const res = await getCountryCitiesListing()
            if (res.data.status === 200) {
                setState({ ...state, country: res.data.data })
            }
        }
        getCountry()
    }, [])

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add fee logic</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth style={{ marginBottom: '10px', marginTop: '10px' }}>
                        <InputLabel id='status'>Status</InputLabel>
                        <Select
                            onChange={(e) => { setState({ ...state, status: e.target.value }) }}
                            fullWidth
                            defaultValue={state.status}
                            id='status' label="status"
                            placeholder='Select status'>
                            <MenuItem value={"Active"}>{"Active"}</MenuItem>
                            <MenuItem value={"Inactive"}>{"Inactive"}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '10px', marginTop: '10px' }}>
                        <InputLabel id='country'>Country</InputLabel>
                        <Select
                            onChange={(e) => { setState({ ...state, selectedCountryId: e.target.value }) }}
                            fullWidth
                            defaultValue={state.selectedCountryId}
                            id='country' label="country"
                            placeholder='Select country'>
                            {state.country.map((data) => <MenuItem value={data.country._id}>{data.country.name}</MenuItem>)}
                        </Select>
                    </FormControl>

                    {state.country.length > 0 && <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <InputLabel id='city'>City</InputLabel>
                        <Select
                            onChange={(e) => { setState({ ...state, selectedCity: e.target.value }) }}
                            fullWidth
                            id='city'
                            defaultValue={state.selectedCity}
                            label="city"
                            placeholder='Select country'>
                            {state.country.map((data) => {
                                if (data.country._id === state.selectedCountryId) {
                                    return data.city.map((data) => <MenuItem value={data.name} >{data.name}</MenuItem>)
                                }
                            })}
                        </Select>
                    </FormControl>}

                    <TextField
                        margin="dense"
                        id="applicableFrom"
                        label="Apply from"
                        type="date"
                        inputProps={{
                            min : moment(new Date()).format("YYYY-MM-DD")
                        }}
                        defaultValue={moment(state.applicableFrom).format("YYYY-MM-DD")}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => { setState({ ...state, applicableFrom: e.target.value }) }}
                    />
                    <TextField
                        margin="dense"
                        id="applicableTo"
                        label="Applicable to"
                        type="date"
                       
                        inputProps={{
                            min : moment(new Date()).format("YYYY-MM-DD")
                        }}
                        defaultValue={moment(state.applicableTo).format("YYYY-MM-DD")}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => { setState({ ...state, applicableTo: e.target.value }) }}
                    />

                    <TextField
                        margin="dense"
                        id="feePerHour"
                        label="Fee per day"
                        type="text"
                        value={state?.feePerHour?.toString().substring(0, 2)}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                            const reg = new RegExp(/^[0-9]*$/gi)
                            const res = reg.test(e.target.value.replace(/\n/g, " "));
                            if (res) {
                                setState({ ...state, feePerHour: e.target.value })
                            }
                        }}
                    />

                    <TextField
                        margin="dense"
                        id="weekendFeePerHour"
                        label="Weekend fee/day"
                        type="text"
                        value={state?.weekendFeePerHour?.toString().substring(0, 2)}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => {
                            const reg = new RegExp(/^[0-9]*$/gi)
                            const res = reg.test(e.target.value.replace(/\n/g, " "));
                            if (res) {
                                setState({ ...state, weekendFeePerHour: e.target.value })
                            }
                        }}
                    />

                    <TextField
                        margin="dense"
                        id="minHours"
                        label="Min. hours"
                        type="text"
                        fullWidth
                        value={state?.minHours?.toString().substring(0, 2)}
                        variant="outlined"
                        onChange={(e) => {
                            const reg = new RegExp(/^[0-9]*$/gi)
                            const res = reg.test(e.target.value.replace(/\n/g, " "));
                            if (res) {
                                setState({ ...state, minHours: e.target.value })
                            }
                        }}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} size="small" >Cancel</Button>
                    <Button onClick={() => handleAddUpdate(state)} variant="contained" size="small" >Update</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const NonaFees = () => {
    const { setSnackBar, setProfileNavTitle, setPageload } = React.useContext(mainContext);
    const [nonaFees, setNonaFees] = React.useState([]);
    const [state, setState] = React.useState({ menuRef: null, openMenu: false, isNumberField: false, id: 0, updatedField: "", nonaFee: {}, index: 0, open: false })


    const getNonaFees = async () => {
        setPageload(true)
        const res = await getNonaFeesController();
        setPageload(false)
        if (res && res.status === 500) {
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }

        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }
        if (res.data.data.length === 0) {
            return setSnackBar({
                status: true,
                text: __snackBarText.noDataFound,
                severity: __snackBarSeverity.info
            });
        }
   
        setNonaFees(res.data.data);
    }

    const handleAddUpdate = async (data) => {
        let request = {}
        if (data && !data._id) {
            if (!data.selectedCountryId) {
                return setSnackBar({
                    status: true,
                    text: "Please select country.",
                    severity: __snackBarSeverity.warning
                })
            }
            else if (!data.selectedCity) {
                return setSnackBar({
                    status: true,
                    text: "Please select city.",
                    severity: __snackBarSeverity.warning
                })
            }
            else if (!data.applicableFrom) {
                return setSnackBar({
                    status: true,
                    text: "Please select applicable from.",
                    severity: __snackBarSeverity.warning
                })
            }
            else if (!data.applicableTo) {
                return setSnackBar({
                    status: true,
                    text: "Please select applicable to.",
                    severity: __snackBarSeverity.warning
                })
            }
            else if (!data.feePerHour) {
                return setSnackBar({
                    status: true,
                    text: "Please add fee per hour.",
                    severity: __snackBarSeverity.warning
                })
            }
            else if (!data.minHours) {
                return setSnackBar({
                    status: true,
                    text: "Please add min. fee per hour.",
                    severity: __snackBarSeverity.warning
                })
            }
            else if (!data.weekendFeePerHour) {
                return setSnackBar({
                    status: true,
                    text: "Please add weekend fee per hour.",
                    severity: __snackBarSeverity.warning
                })
            }

        }
        request = {
            feePerHour: parseInt(data.feePerHour),
            minHours: parseInt(data.minHours),
            weekEndFeePerHour: parseInt(data.weekendFeePerHour),
            countryId: data.selectedCountryId,
            city: data.selectedCity,
            applicableFrom: moment(data.applicableFrom).format("YYYY-MM-DD"),
            applicableTo: moment(data.applicableTo).format("YYYY-MM-DD"),
            status: data.status,
            _id: data._id
        }

        setPageload(true)
        const res = await addNonaFeesController(request);
        setPageload(false)
        if (res.data.status === 200) {
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.success
            });
            if (data._id) { /* Update nona Fee */
                let index = nonaFees.findIndex((object => data._id == object._id))
                nonaFees[index] = res.data.data
                setNonaFees(nonaFees)
                setState({ ...state, openMenu: false, open: false })
            }
            else {
                let newNonaFeev = nonaFees
                newNonaFeev.unshift(res.data.data)
                setNonaFees(newNonaFeev);
                setState({ ...state, openMenu: false, open: false })
            }
        } else {
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }


    }

    const handleDelete = async (id, index) => {
        
        let confirm = window.confirm("Do you want to remove nona fees.")
        if(!confirm){
            return
        }
        setPageload(true)
        const res = await removeNonaFee(id);
        setPageload(false)
        if (res.data.status === 200) {
            nonaFees.splice(index, 1)
            setNonaFees(nonaFees)
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.success
            });
        } else {
            setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }

    }

    React.useEffect(() => {
        getNonaFees();
        setProfileNavTitle("Nona Fees");
        // eslint-disable-next-line
    }, [])

   

    return (
        <>
            {state.open && <FormDialog
                nonaFee={state.nonaFee}
                open={state.open}
                handleClose={() => setState({ ...state, open: false, nonaFee: {} })}
                handleAddUpdate={handleAddUpdate} />}
            <Conatiner>
                <Header>
                    <Button variant="contained" size='small' onClick={() => setState({ ...state, open: true })}>Add fee</Button>
                </Header>
                <Body>
                    <List>
                        <div className="header">Status</div>
                        <div className="header">City</div>
                        <div className="header">Fee/day</div>
                        <div className="header">Weekend Fee/day</div>
                        <div className="header">Min. hours</div>
                        <div className="header">Applicable from</div>
                        <div className="header">Applicable till</div>
                    </List>
                    <Divider className='divider-gap' />
                    {
                        nonaFees.map((fee, index) =>
                            <List key={fee._id}>
                                <div>
                                    <div className={`list_card_status ${fee.status === "Active" ? "status_active" : fee.status === "Inactive" ? "status_inactive" : "status_pending"} `}>{fee.status}</div>
                                </div>
                                <div>
                                    {fee.city}
                                </div>
                                <div>
                                    {fee.feePerHour}
                                </div>
                                <div>
                                    {fee.weekEndFeePerHour}
                                </div>
                                <div>
                                    {fee.minHours}
                                </div>
                                <div>
                                    {moment(fee.applicableFrom).format("MMM DD, YYYY")}
                                </div>
                                <div>
                                    {moment(fee.applicableTo).format("MMM DD, YYYY")}
                                </div>

                                <div style={{display:"flex"}}>
                                    <Edit className='pointer' sx={{ marginRight: 2 }} onClick={() => { setState({ ...state, nonaFee: fee, index, open: true }) }} />
                                    <Delete className='pointer' onClick={() => handleDelete(fee._id,index)} />
                                </div>
                            </List>)
                    }
                </Body>

            </Conatiner>

            {/* Handle Open Menu for Edit field */}
            <EditMenu
                id={state.id}
                title={"Update"}
                menuRef={state.menuRef}
                open={state.openMenu}
                onSave={(data, id) => handleAddUpdate(data, true, id)}
                onCancel={() => setState({ ...state, openMenu: false })}
                isActiveDropdown={state.isActiveDropdown}
                isNumberField={state.isNumberField}
                isDateField={state.isDateField}
                currentValue={state.value}
            />
        </>
    )
}

const Conatiner = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
`;

const Header = styled("div")`
  button{
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  height: 80vh;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
div{
    margin-right:10px
}
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 1.5fr 1.5fr 1.5fr 2fr  2fr 2.5fr 2fr 1fr;
`;

export default NonaFees